import { render, staticRenderFns } from "./news7.vue?vue&type=template&id=4d0907d5&scoped=true&"
import script from "./news7.vue?vue&type=script&lang=js&"
export * from "./news7.vue?vue&type=script&lang=js&"
import style0 from "./news7.vue?vue&type=style&index=0&id=4d0907d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0907d5",
  null
  
)

export default component.exports